import {
  ContentLayout,
  ContentMain,
  ContentTip,
} from '@/components/ContentLayout'
import type { ReactNode } from 'react'
import { Form, FormActions, FormSection } from '@/components/Form'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgTeamAnalyticsUrl from '@/assets/misc/img_team-analytics.svg'
import TeamAnalyticsIllustration from '@/components/SpotIllustration/TeamAnalyticsIllustration'

export interface TeamDetailsProps {
  onSubmit: () => unknown
  detailsFields?: ReactNode
  addressFields?: ReactNode
  canEditDetails: boolean
  isSavePending: boolean
  hasChanges: boolean
  corporateMode: boolean
}

export function TeamDetails({
  onSubmit,
  detailsFields,
  addressFields,
  canEditDetails,
  isSavePending,
  hasChanges,
  corporateMode,
}: TeamDetailsProps) {
  return (
    <ContentLayout accountForLabel accountForTabBar>
      <ContentMain>
        <Form onSubmit={() => onSubmit()}>
          <FormSection label="Team Details">{detailsFields}</FormSection>
          <FormSection label="Team Address">{addressFields}</FormSection>
          {canEditDetails && (
            <FormActions>
              <Button
                label="Save"
                type="submit"
                variant="primary"
                isPending={isSavePending}
                isDisabled={isSavePending || !hasChanges}
              />
            </FormActions>
          )}
        </Form>
      </ContentMain>
      <ContentTip
        corporateMode={corporateMode}
        title="Get more out with Team Analytics!"
        illustrationUrl={corporateMode ? undefined : imgTeamAnalyticsUrl}
        illustration={
          corporateMode
            ? undefined
            : byDesign(undefined, TeamAnalyticsIllustration)
        }
      >
        Are you looking to get more out of your team data? We can help.
      </ContentTip>
    </ContentLayout>
  )
}
